import { render, staticRenderFns } from "./JudgeFormComponent.vue?vue&type=template&id=0da179e9"
import script from "./JudgeFormComponent.vue?vue&type=script&lang=js"
export * from "./JudgeFormComponent.vue?vue&type=script&lang=js"
import style0 from "./JudgeFormComponent.vue?vue&type=style&index=0&id=0da179e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports